module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.f3489dc9.svg";